var Kowloon = "Kowloon";
var HKStates = {
	"Hong Kong Island": "Île de Hong Kong",
	Kowloon: Kowloon,
	"Lantau Island": "Île de Lantau",
	"New Territories": "Nouveaux Territoires"
};

export { Kowloon, HKStates as default };
